import React, { useState, useEffect, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { config } from '../server'
import {PlanContext} from '../Store'
import { useAuth0 } from '@auth0/auth0-react';

const stripePromise = loadStripe('pk_test_51ICZLIC2tifyN8JCYTA4HqLIvAYmpsNs0P6V4JEjoFIQQm1FH5Yt1AwG4h7U66r92w3Q3q8SDu7S4FxFAgc9svZc007DFT5EVg');
const address = config.url.API_URL


const Message = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
);

export default function ParentPurchase() {
  const [message, setMessage] = useState("");
  const [, setPlan] = useContext(PlanContext)
  const { user } = useAuth0()

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const handlePlan = async (planType) => {
      const requestOptions = {
      method: 'POST',
      headers: { 
      'content-type': 'application/json' },
      body: JSON.stringify({ name: user.nickname, plan: planType, email: user.email })
    };
      const res = await fetch(address + '/plans', requestOptions)
      const data = await res.json()
      setPlan(data.planType)
  }
    const query = new URLSearchParams(window.location.search);
    if (query.get("success")) {
      setMessage("Thank you for your purchase! Click on any of the menu items to get started!");
      handlePlan("parent")
    }
    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
  }, [setPlan, user]);

  
  const handleClick = async (event) => {
    // When the customer clicks on the button, redirect them to Checkout.

    const stripe = await stripePromise;

    const requestOptions = {
      method: 'POST',
      headers: { 
      'content-type': 'application/json' },
      body: JSON.stringify({ priceId: 'price_1IKRHMC2tifyN8JCEt3YviYv' })
  };
    const response = await fetch(address + "/create-checkout-sessionId", requestOptions);


    const session = await response.json();
    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.sessionId,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      alert(result.error.message)
    }

   /* createCheckoutSession('price_1IEGRAC2tifyN8JCoPlF3Zsg').then(function(data) {
      // Call Stripe.js method to redirect to the new Checkout page
      stripe
        .redirectToCheckout({
          sessionId: data.sessionId
        }).then(function(result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, you should display the localized error message to your
          // customer using `error.message`.
          console.log(result)
          if (result.error) {
            alert(result.error.message);
          }
        })
        .then((error) => console.log(error));
    });*/
  };

  return message ? (
    <Message message={message} />
  ) : (
    <>
    <button className="tealBtn" role="link" onClick={handleClick}>
      Parent Plan
    </button>  
    </>
    );
}